app.factory("Migration", ["$http", "$log",
    function ($http, $log) {
        var Migration = {};

        Migration.list = function (params) {
            return $http.get("/migration/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    program: params.program,
                    subject: params.subject
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Migration.save = function (params) {
            return $http.post('/migration/save', {
                newProgram: params.newProgram,
                newSubject: params.newSubject,
                migration: params.migration
            }).then(function (resp) {
                return resp.data;
            })
        };

        Migration.searchProgram = function (program) {
            return $http.get("/migration/search", {
                params: {
                    program: program
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        return Migration;
    }
]);